import { formatCurrency, formatCurrencyWhole } from '../utils/api';
import { useIsMobile } from '../utils/useIsMobile';
import ListRow from './ListRow';
import PriceRange from './PriceRange';
import { RowChangeChip } from './TopProductSheet';

// The top-products REPORT's list rows and their header strip
// (/analysis/reports/top-products below 1200px). Moved out of TopProductsCard
// when the card became a plain table (owner + product-design review,
// 21/10/2026). A row opens its orders: the bottom sheet on a phone, sub-lines
// under the row from 641px (owner, 22/10/2026).

// The header strip: labels the end column once for the rows beneath it.
export function TopProductsColumnHead() {
  // Phones carry no end-column labels: the row has no bar there, and the
  // card subtitle names the price (mobile-design review, 20/10/2026).
  const phone = useIsMobile(640);
  if (phone) return null;
  return (
    <div className="top-products-head" aria-hidden="true">
      <span className="top-products-head-cell">
        <span>מחיר נוכחי</span>
        <span className="top-products-head-range" dir="ltr"><span>מינ׳</span><span>מקס׳</span></span>
      </span>
    </div>
  );
}

// One product row of the REPORT's list (below 1200px). Needs a
// `.top-products` ancestor for its layout. The /analysis card no longer uses
// it — the card is a plain, non-clickable table (owner, 21/10/2026); the
// detail (orders, min–max) lives here, in the report.
// `phone` comes from the parent — one matchMedia listener per list, not one
// per row (the report can render hundreds; perf self-review, 20/10/2026).
export function TopProductRow({ row: r, onOpen, phone = false, expanded = false }) {
  // PHONES (≤640px, the density breakpoint) get the ticker row the mobile
  // design review chose with real data (owner picked it, 20/10/2026): long
  // product and supplier names are the norm there, and a fixed price-and-bar
  // column took half the row, cutting both to a few letters while most rows
  // (one purchase in the month) printed only "קנייה אחת" in it. So on a phone:
  //   line 1  name                    │ price · chip slot
  //   line 2  supplier                │ סה״כ ₪…
  // no rank (the order is the rank), no chevron (the whole row is the tap),
  // no bar — it opens at the top of the sheet. The end column is as wide as
  // its content; the chip keeps a fixed slot so prices still line up.
  if (phone) {
    return (
      <ListRow
        variant="plain"
        className="top-products-phone-row"
        primary={r.name}
        meta={<span className="top-products-sup">{r.supplier_name}</span>}
        amount={(
          <span className="top-products-price">
            {r.current_price == null ? '—' : formatCurrency(r.current_price)}
            <span className="top-products-chip-slot"><RowChangeChip row={r} /></span>
          </span>
        )}
        endSub={<span className="top-products-total">סה״כ {formatCurrencyWhole(r.spend)}</span>}
        onClick={() => onOpen(r)}
      />
    );
  }
  return (
    <ListRow
      primary={<><span className="top-products-rank">{r.rank}</span>{r.name}</>}
      // The supplier name gives way (ellipsis) before the total ever does.
      meta={<>
        <span className="top-products-sup">{r.supplier_name}</span>
        <span className="top-products-total">· סה״כ {formatCurrencyWhole(r.spend)}</span>
      </>}
      amount={(
        <span className="top-products-price">
          {r.current_price == null ? '—' : formatCurrency(r.current_price)}
          <RowChangeChip row={r} />
        </span>
      )}
      endSub={<PriceRange row={r} />}
      variant="accordion"
      expanded={expanded}
      onClick={() => onOpen(r)}
    />
  );
}
